export const clinicalCredentials = [
  'Physician (MD, DO)',
  'Physician Asst. (PA)',
  'Nurse Practitioner (NP)',
  'Registered Nurse (RN)',
  'Clinical Nurse Specialist (CNS)',
  'Discharge Planner',
  'Other',
] as const;
